'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'styles/ListItemCellRight.scss';

const propTypes = {
    value: PropTypes.string,
    unit: PropTypes.string,
    altValue: PropTypes.string,
    altUnit: PropTypes.string,
    id: PropTypes.string,
};

class ListItemCellRight extends React.Component {

    render() {

        var value = this.props.value ? <span className="value">{this.props.value}{this.props.unit ? <span className="unit">{" " + this.props.unit}</span> : null}</span> : null;
        var altValue = this.props.altValue ? <span className="alt-value-unit"><br />{this.props.altValue}{this.props.altUnit ? " " + this.props.altUnit : ""}</span> : null;
        
        return (
            <div className="list-item-cell-right">
                {value}
                {altValue}
            </div>
        );
    }
}

ListItemCellRight.propTypes = propTypes;

export default ListItemCellRight; 